module.exports = __webpack_public_path__ + "img/IS471008-0280.08f74b9b.png";